import React from "react";

const Pagination = ({
  page,
  totalPages,
  hasPrevPage,
  hasNextPage,
  goToPrevPage,
  goToNextPage,
}) => {

  // ✅ Hide pagination if only 1 page
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="w-full mt-6">
      <div className="flex items-center justify-between bg-white shadow-md rounded-xl px-6 py-4">

        {/* Previous */}
        <button
          onClick={goToPrevPage}
          disabled={!hasPrevPage}
          className="px-5 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-40"
        >
          Previous
        </button>

        {/* Page Info */}
        <div className="text-gray-700 font-medium">
          Page {page} of {totalPages}
        </div>

        {/* Next */}
        <button
          onClick={goToNextPage}
          disabled={!hasNextPage}
          className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40"
        >
          Next
        </button>

      </div>
    </div>
  );
};

export default Pagination;